<template>
    <div class="afaq-category">
        <div
            class="hidden-anchor"
            :id="'afaq-category-title-' + categoryIn.id"></div>
        <div
            class="page-header"
            role="tab">
            <b-button
                class="btn-page-content-toggle"
                @click="collapse()"
                :class="collapsed && 'active'"
                block
                variant="outline-primary">
                <div class="title page-title">
                    {{ liveCategory.name }}
                </div>

                <i class="fas fa-fw fa-chevron-down state-icon"></i>

                <div class="context-nav context-step-page-nav">
                    <b-dropdown
                        class="ellipsis-nav bordered-menu step-page-nav"
                        no-caret
                        variant="primary"
                        right
                        toggle-class="step-page-context-menu">
                        <template v-slot:button-content>
                            <i class="fas fa-ellipsis-v"></i>
                        </template>

                        <b-dropdown-item
                            class="edit-step"
                            @click.prevent.stop="changeCategory()">
                            <i class="btn-edit"></i>
                            {{ $t('admin.edit_category') }}
                        </b-dropdown-item>

                        <b-dropdown-item
                            class="remove-step"
                            @click.prevent.stop="deleteCategory()">
                            <i class="btn-remove"></i>
                            {{ $t('admin.delete_category') }}
                        </b-dropdown-item>

                        <!--                    <design-2021-edit-afaq-category-modal-component-->
                        <!--Moet anders                        :step-in="categoryIn"-->
                        <!--                        ref="afaq-edit-category-modal"-->
                        <!--                    ></design-2021-edit-afaq-category-modal-component>-->
                    </b-dropdown>
                </div>
            </b-button>
        </div>
        <div class="col-12">
            <b-collapse
                class="page-content"
                v-model="collapsed"
                :id="'afaq-category-content-' + categoryIn.id"
                role="tabpanel">
                <draggable
                    group="questions"
                    :list="categoryIn.afaq_question_answers"
                    handle=".category-part-drag-handle"
                    @change="orderChanged()"
                    ghost-class="drag-ghost">
                    <div
                        class="question"
                        v-for="question in categoryIn.afaq_question_answers"
                        :key="question.id">
                        <design-2021-afaq-question-answer-edit-component
                            :question-in="question"
                            :category-in="categoryIn"
                            @editQuestion="editQuestion($event)">
                        </design-2021-afaq-question-answer-edit-component>
                    </div>
                </draggable>
                <div class="add-question">
                    <b-button
                        v-b-modal="'create-afaq-question-modal-' + categoryIn.id"
                        variant="primary"
                        :v-b-tooltip="$t('admin.new_question')">
                        {{ $t('admin.new_q_and_a') }}
                    </b-button>
                </div>
            </b-collapse>
        </div>
        <design-2021-afaq-edit-question-modal-component
            :ref="'edit-afaq-question-modal-' + categoryIn.id"
            :afaq-tags-in="afaqTagsIn"
            :category-in="categoryIn">
        </design-2021-afaq-edit-question-modal-component>
        <design-2021-afaq-add-question-modal-component
            ref="create-afaq-question-modal"
            :afaq-tags-in="afaqTagsIn"
            :category-in="categoryIn">
        </design-2021-afaq-add-question-modal-component>
    </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    name: 'design-2021-afaq-category-component',
    props: ['categoryIn', 'afaqTagsIn'],
    components: {
        draggable,
    },
    data() {
        return {
            category: this.categoryIn,
            collapsed: true,
            questions: this.categoryIn.afaq_question_answers,
        };
    },
    computed: {
        liveCategory() {
            return this.category;
        },
        order() {
            return this.questions.length;
        },
    },
    methods: {
        changeCategory() {
            this.$emit('editCategory', this.category);
        },
        editQuestion(question) {
            this.$refs['edit-afaq-question-modal-' + this.categoryIn.id].show(question);
        },
        deleteCategory() {
            this.alert
                .confirm('delete_category_are_you_sure_you_want_to_the_delete_this_account_delete')
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.alert.saving();
                    this.axios
                        .delete(this.routes.adminAfaqCategory(), { data: { categoryId: this.categoryIn.id } })
                        .then(
                            (response) => {
                                this.categoryIn.remove();
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                });
        },
    },
};
</script>

<style scoped lang="scss"></style>
